module.exports = __webpack_public_path__ + "img/mg_ptdx.66350b6e.png";